import { createSlice, PayloadAction } from '@reduxjs/toolkit'


interface AssistantsState {
    activeId?: string;
    lastUpdate?: number;
    chatWaitsForResponse: boolean;
}

const initialState: AssistantsState = {
    activeId: undefined, // id of active assistant
    lastUpdate: undefined, // timestamp of last update of active assistance instance
    chatWaitsForResponse: false, // boolean to indicate if chat is waiting for response, and thus eg the input field is blocked
}

export const assistantsSlice = createSlice({
    name: 'assistants',
    initialState,
    reducers: {
        updateActiveId: (state, action: PayloadAction<{ id: string }>) => {
            state.activeId = action.payload.id
        },
        updateLastUpdate: (state, action: PayloadAction<{ timestamp: number }>) => {
            state.lastUpdate = action.payload.timestamp
        },
        updateChatWaitsForResponse: (state, action: PayloadAction<{ waiting: boolean }>) => {
            state.chatWaitsForResponse = action.payload.waiting
        },
    },
})

export const {
    updateActiveId,
    updateLastUpdate,
    updateChatWaitsForResponse,
} = assistantsSlice.actions

export default assistantsSlice.reducer
